export default __webpack_public_path__ + "static/media/hire-purchase-chart-2.7cc9dddf.svg";